import { createI18n } from 'vue-i18n';
import { fr, es, en, it, pt, ja, nl, de } from './src/utils/themesTranslation';
import { cfr, cfr_es, cfr_en, cfr_if, cfr_pt, cfr_ja, cfr_nl, cfr_de } from './src/utils/countriesTranslation';

const messages = {
    en: {
        filter: 'Filter ads',
        countries: 'All countries',
        country: 'Concerned country',
        themes: 'All themes',
        expression: 'What would you like to report?',
        name: 'Your name...',
        map: 'See for yourself!',
        anonymous: 'Anonymous',
        content: 'Express yourself...',
        category: 'Choose a category',
        publish: 'Publish',
        cancel: 'Cancel',
        allTheme: en,
        allCountry: cfr_en
    },
    es: {
        filter: 'Filtrar anuncios',
        countries: 'Todos los países',
        country: 'País en cuestión',
        themes: 'Todos los temas',
        expression: '¿Qué le gustaría denunciar?',
        name: 'Tu nombre...',
        map: '¡Mira por ti mismo!',
        anonymous: 'Anónimo',
        content: 'Exprésate...',
        category: 'Elige una categoría',
        publish: 'Publicar',
        cancel: 'Cancelar',
        allTheme: es,
        allCountry: cfr_es
    },
    de: {
        filter: 'Anzeigen filtern',
        countries: 'Alle Länder',
        country: 'Betroffenes Land',
        themes: 'Alle Themen',
        expression: 'Was möchten Sie melden?',
        name: 'Ihr Name...',
        map: 'Schauen Sie selbst!',
        anonymous: 'Anonym',
        content: 'Drücken Sie sich aus...',
        category: 'Wählen Sie eine Kategorie',
        publish: 'Veröffentlichen',
        cancel: 'Abbrechen',
        allTheme: de,
        allCountry: cfr_de
    },
    it: {
        filter: 'Filtra annunci',
        countries: 'Tutti i paesi',
        country: 'Paese interessato',
        themes: 'Tutti i temi',
        expression: 'Cosa vorresti denunciare?',
        name: 'Il tuo nome...',
        map: 'Guarda tu stesso!',
        anonymous: 'Anonimo',
        content: 'Esprimiti...',
        category: 'Scegli una categoria',
        publish: 'Pubblica',
        cancel: 'Annulla',
        allTheme: it,
        allCountry: cfr_if
    },
    pt: {
        filter: 'Filtrar anúncios',
        countries: 'Todos os países',
        country: 'País em questão',
        themes: 'Todos os temas',
        expression: 'O que você gostaria de denunciar?',
        name: 'Seu nome...',
        map: 'Veja por si mesmo!',
        anonymous: 'Anônimo',
        content: 'Expresse-se...',
        category: 'Escolha uma categoria',
        publish: 'Publicar',
        cancel: 'Cancelar',
        allTheme: pt,
        allCountry: cfr_pt
    },
    nl: {
        filter: 'Advertenties filteren',
        countries: 'Alle landen',
        country: 'Betrokken land',
        themes: 'Alle thema\'s',
        expression: 'Wat wilt u melden?',
        name: 'Uw naam...',
        map: 'Kijk zelf!',
        anonymous: 'Anoniem',
        content: 'Druk u uit...',
        category: 'Kies een categorie',
        publish: 'Publiceren',
        cancel: 'Annuleren',
        allTheme: nl,
        allCountry: cfr_nl
    },
    fr: {
        filter: 'Filtrer les annonces',
        countries: 'Tous les pays',
        country: 'Pays concerné',
        themes: 'Tous les thèmes',
        expression: 'Que voulez-vous dénoncer ?',
        name: 'Votre nom...',
        map: 'Toi même regarde !',
        anonymous: 'Anonyme',
        content: 'Exprimez-vous...',
        category: 'Choisissez une catégorie',
        publish: 'Publier',
        cancel: 'Annuler',
        allTheme: fr,
        allCountry: cfr
    },
    ja: {
        filter: '広告をフィルタリング',
        countries: 'すべての国',
        country: '関係国',
        themes: 'すべてのテーマ',
        expression: '何を告発したいですか？',
        name: 'あなたの名前...',
        map: '自分で見てください！',
        anonymous: '匿名',
        content: '自分を表現してください...',
        category: 'カテゴリを選択',
        publish: '公開',
        cancel: 'キャンセル',
        allTheme: ja,
        allCountry: cfr_ja
    },
};



// Détecter la langue du navigateur
const userLanguage = navigator.language.split('-')[0] || 'en';
const lang = localStorage.getItem('language') || userLanguage;

// Créer une instance de vue-i18n
const i18n = createI18n({
    legacy: false, // Permet d'utiliser la syntaxe Composition API
    locale: lang, // Définit la langue actuelle
    fallbackLocale: 'en', // Langue par défaut en cas de non-disponibilité
    messages, // Charge les traductions
    missingWarn: false, // Désactive les avertissements de clé manquante
    fallbackWarn: false, // Désactive les avertissements de fallback de langue
    warnHtmlInMessage: 'off', // Désactive les avertissements concernant les messages HTML
    silentTranslationWarn: true,
});

export default i18n;
